import { render, staticRenderFns } from "./BaseStartMeetingButton.vue?vue&type=template&id=1fa69061&scoped=true&"
import script from "./BaseStartMeetingButton.vue?vue&type=script&lang=js&"
export * from "./BaseStartMeetingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa69061",
  null
  
)

export default component.exports